import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { BarTitle } from "../components/CollapseBar";
import { Handshake } from "lucide-react";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
const B = ({ l, v, tid }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/40 p-2 text-xs">
    <div className="mb-1 font-bold text-slate-300">{l}</div>
    <div data-testid={tid} className="grid grid-cols-2 gap-x-3 gap-y-0.5 text-slate-300">
      <span>KARGO</span><b className="text-white">{v.adet} (TESLİM {v.teslim})</b>
      <span>TOPLAM</span><b className="text-white">{tl(v.toplam)}</b>
      <span>TAHSİL</span><b className="text-emerald-300">{tl(v.tahsil)}</b>
      <span>KALAN</span><b className={v.kalan > 0 ? "text-rose-300" : v.kalan < 0 ? "text-amber-300" : "text-emerald-300"}>{tl(v.kalan)}</b>
    </div>
  </div>
);

export default function OrtakHesap() {
  const [d1, setD1] = useState(""); const [d2, setD2] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/partner-summary", { params: { d1, d2 } }).then((r) => setRows(r.data)); }, [d1, d2]);
  return (
    <div data-testid="partner-summary-page" className="mw-fade-up space-y-3">
      <BarTitle><h1 className="font-head flex items-center gap-2 text-2xl font-bold text-white"><Handshake className="h-6 w-6 text-emerald-400" /> KARŞILIKLI HESAP ÖZETİ</h1></BarTitle>
      <div className="flex items-center gap-2 text-sm text-slate-300">İLK <input data-testid="ps-d1" type="date" value={d1} onChange={(e) => setD1(e.target.value)} className="h-9 rounded border border-slate-700 bg-slate-800 px-2 text-slate-100" />
        SON <input data-testid="ps-d2" type="date" value={d2} onChange={(e) => setD2(e.target.value)} className="h-9 rounded border border-slate-700 bg-slate-800 px-2 text-slate-100" /></div>
      {rows.length <= 1 && <div className="text-sm text-slate-500">ORTAK FİRMA YOK (SÜPER ADMİN FİRMA YÖNETİMİ'NDEN EKLER)</div>}
      <div className="grid gap-3 md:grid-cols-2">
        {rows.map((r) => (
          <div key={r.partner} data-testid={`ps-card-${r.partner}`} className={`space-y-2 rounded-xl border p-3 ${r.kendi ? "border-emerald-700 bg-slate-900 md:col-span-2" : "border-slate-800 bg-slate-900"}`}>
            <div className="text-base font-bold text-white">{r.partner_name}</div>
            <div className={`grid gap-2 ${r.kendi ? "grid-cols-3" : "grid-cols-2"}`}><B l={r.kendi ? "TÜM KESTİĞİMİZ" : "GÖNDERDİĞİMİZ"} v={r.gonderilen} tid={`ps-out-${r.partner}`} /><B l={r.kendi ? "TÜM BİZE GELEN" : "BİZE GELEN"} v={r.gelen} tid={`ps-in-${r.partner}`} />{r.kendi && <B l="KENDİ DAĞITIMIMIZ" v={r.kendi} tid="ps-own" />}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
